export enum ProcessTypeFeatureFlags{
    pme = 1,
    pmq = 2,
    _360 = 3,
    combined = 4
}